module.exports = __webpack_public_path__ + "static/media/job_category_12.ee54e8de.png";